import React from 'react';
import { useRecordContext, Link } from 'react-admin';

// Renders a nested relation that may be either an embedded object ({ id, ... })
// or an IRI string (e.g. "/users/42"). Optionally links to the related resource.
const NestedReferenceField = ({ source, labelField = 'name', resource, link = true, ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  const value = record[source];
  if (value == null) return <span {...props}>—</span>;

  if (typeof value === 'string') {
    // IRI string like "/users/42"
    const match = value.match(/^\/([^/]+)\/(.+)$/);
    if (link && match) {
      const [, res, id] = match;
      return (
        <Link to={`/${res}/${id}`} {...props}>
          {value}
        </Link>
      );
    }
    return <span {...props}>{value}</span>;
  }

  // Embedded object
  const display = value[labelField] ?? value.email ?? value.id ?? JSON.stringify(value);
  if (link && resource && value.id != null) {
    return (
      <Link to={`/${resource}/${value.id}/show`} {...props}>
        {display}
      </Link>
    );
  }
  return <span {...props}>{display}</span>;
};

export default NestedReferenceField;
